import { useUser } from 'hooks/useUser';
import { type ComponentProps, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import CreateQuestionLayout from '../CreateQuestion/Layout';
import MainPanel from '../CreateQuestion/MainPanel';
import { CloseQuestion } from './CloseQuestion';
import { CopyAndSwapQuestion } from './CopyAndSwapQuestion';
import { SaveQuestion } from './SaveQuestion';

interface Props extends ComponentProps<'div'> {
  children?: ReactNode;
}

const CreateQuestionComponent = ({ children, ...props }: Props) => {
  const { t } = useTranslation('Questionsv2');
  const user = useUser();

  if (!user) {
    return <div>{t('createQuestionComponent.userNotAvailable')}</div>;
  }

  return (
    <CreateQuestionLayout leftContent={<MainPanel />} {...props}>
      {children}
    </CreateQuestionLayout>
  );
};

CreateQuestionComponent.Save = SaveQuestion;
CreateQuestionComponent.CopyAndSwapQuestion = CopyAndSwapQuestion;
CreateQuestionComponent.Close = CloseQuestion;

export default CreateQuestionComponent;
